export const Paginationlimit = 10;
export const DashboardPaginationLimit = 5;
